import { atLeast } from "./levels.js";

const isImpliedAt =
  (level) =>
  ({ impliedLevel }) =>
    Boolean(impliedLevel) && atLeast(impliedLevel)(level);

export const effectivePermissions = (level, rows) =>
  rows
    .filter((row) => Boolean(row.granted) || isImpliedAt(level)(row))
    .map(({ permission }) => permission);

const holds = (action, { permissions = [] }) => permissions.includes(action);

export const can = (action, resource, identity) =>
  identity.level === "owner" || holds(action, identity);

export const deniedActions = (actions, resource, identity) =>
  actions.filter((action) => !can(action, resource, identity));
